import styled, { css } from 'styled-components';
import { Heading, Box, Avatar, Text } from '@bechtel/gds';
import { Scalars } from '@bechtel/types';

export const HeadingStyled = styled(Heading).attrs({
  size: '400',
  color: 'grey.1000',
})`
  padding-top: ${({ theme }) => theme.spacings[100]};
  padding-bottom: ${({ theme }) => theme.spacings[100]};
  white-space: nowrap;
`;

export interface ReplanExpiredMilestoneStyledProps {
  isAllOrUnassignedSup: Scalars['Boolean'];
}

export const ReplanExpiredMilestoneStyled = styled(Box).attrs({
  flexGrow: { sm: 1 },
  alignItems: { sm: 'center' },
  justifyContent: { sm: 'center' },
  py: { sm: '300' },
  mr: { sm: '400' },
})<ReplanExpiredMilestoneStyledProps>`
  ${({ theme, isAllOrUnassignedSup }) => css`
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 2px 1px -1px rgba(0, 0, 0, 0.12), 0 1px 1px 0 rgba(0, 0, 0, 0.14);
    border-radius: ${theme.radii[400]};
    background-color: ${isAllOrUnassignedSup ? theme.colors.grey[200] : theme.colors.white};
    white-space: nowrap;
  `}
`;

export interface AvatarRegularStyledProps {
  hasImageUrl: boolean;
}

export const AvatarRegularStyled = styled(Avatar)<AvatarRegularStyledProps>`
  border-width: 1px !important;
  ${({ theme, hasImageUrl }) => css`
    border-color: ${theme.colors.white};
    background-color: ${hasImageUrl ? theme.colors.white : theme.colors.grey[200]};
  `}
`;

export const OwnerNameStyled = styled(Box).attrs({ mt: { sm: '300' } })`
  ${({ theme }) => css`
    padding-bottom: ${theme.spacings[100]};
    text-align: center;
  `}
`;

export const ForemanCollapsedStyled = styled(Box).attrs({ justifyContent: { sm: 'space-between' }, p: { sm: '400' } })`
  ${({ theme }) => css`
    background-color: ${theme.colors.white};
  `}
`;

export const ForemanHeaderStyled = styled(Box).attrs({
  p: { sm: '500' },
  justifyContent: { sm: 'space-between' },
})`
  ${({ theme }) => css`
    background-color: ${theme.colors.grey[200]};
    border-bottom: solid 1px ${theme.colors.grey[300]};
    cursor: pointer;
  `}
`;

export const NoHierachyTextStyled = styled(Text).attrs({})`
  ${({ theme }) => css`
    margin-bottom: ${theme.spacings[500]};
  `}
`;
